import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";
import { useAppSelector } from "@/hooks/types";
import { getIsUserJobsEnabled } from "@/store/tenant/selectors";

interface HelpGuideAtsScanProps {
    onClose: () => void;
}

export const HelpGuideAtsScan = ({ onClose }: HelpGuideAtsScanProps) => {
    const isUserJobsEnabled = useAppSelector(getIsUserJobsEnabled);
    return (
        <div>
            <ModalHeader
                title="ATS Scanner"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    The ATS Scanner provides comprehensive analysis of your
                    resume across four key areas:
                </AppText>

                <div className="mb-2">
                    <h4 className="font-semibold">1. Content Quality</h4>
                    <ul className="ml-4 list-disc">
                        <li>
                            <AppText variant="regular">
                                Work Experience Relevance & Achievements
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                Skills Alignment
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">Summary Impact</AppText>
                        </li>
                    </ul>
                </div>

                <div className="mb-2">
                    <h4 className="font-semibold">2. ATS Compatibility</h4>
                    <ul className="ml-4 list-disc">
                        <li>
                            <AppText variant="regular">
                                Keyword Optimization
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                Standard Formatting & Structure
                            </AppText>
                        </li>
                    </ul>
                </div>

                <div className="mb-2">
                    <h4 className="font-semibold">3. Writing & Language</h4>
                    <ul className="ml-4 list-disc">
                        <li>
                            <AppText variant="regular">
                                Grammar, Spelling & Punctuation
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                Action Verbs & Tone
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                Clarity & Conciseness
                            </AppText>
                        </li>
                    </ul>
                </div>

                <div className="mb-2">
                    <h4 className="font-semibold">4. Format & Design</h4>
                    <ul className="ml-4 list-disc">
                        <li>
                            <AppText variant="regular">
                                Visual Hierarchy & Readability
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                Formatting Consistency
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                Length & White Space
                            </AppText>
                        </li>
                    </ul>
                </div>

                {isUserJobsEnabled ? (
                    <AppText
                        variant="regular"
                        className="mb-2"
                    >
                        If a job description is attached to the resume, the
                        scanner scanner will automatically use it for targeted
                        feedback. While not required, attaching a job
                        description is encouraged for more relevant and specific
                        recommendations. Each category provides detailed
                        feedback with priority levels to help you focus on the
                        most important improvements.
                    </AppText>
                ) : (
                    <AppText
                        variant="regular"
                        className="mb-2"
                    >
                        Each category provides detailed feedback with priority
                        levels to help you focus on the most important
                        improvements.
                    </AppText>
                )}
            </HelpContentContainer>
        </div>
    );
};
